import { ThemeColors } from '../../../../tokens/colors/types';
import { blue, green, neutral, orange, purple, red } from './palette';
import { deals } from './product';
import { critical, info, positive, warning } from './semantic';

const primary: ThemeColors['primary'] = {
  '10': '#F3F9FF',
  '20': '#E6F3FF',
  '30': '#E8ECFB',
  '50': '#1E44D5',
  '70': '#003399',
  '90': '#002C52',
};

const secondary: ThemeColors['secondary'] = {
  '20': '#FFFAE5',
  '30': '#FFEDA3',
  '50': '#FFCC00',
  '70': '#DBAF00',
  '90': '#8F7200',
};

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  info,
  warning,
  critical,
  positive,
  deals,
};

export default baseColors;
